<template lang="">
  <div>
    <div id="FooterZone" ismodulecontainer="true"
          class="FooterContainer FooterZoneContainer ZoneContainer FooterZone ModuleContainer clearfix ">
          <div class="ModuleItem  StaticModule  " wo="1358" id="module_63127565" style="height: auto;">

            <div class="ModuleGridGiant layout-101 layout-color- module_63127565 clearfix">

              <div class="BodyCenter BodyCenter63127565 clearfix">

                <div class="ModuleGridContainer  ModuleGridContainer63127565" gridswidthmode="2">

                  <div class="row ModuleSubContainer">

                    <div class="gridBgVideo noBgVideo">

                      <video src="" class="bgVideo" autoplay="" loop="loop"></video>

                      <div class="bgVideoMask"></div>

                    </div>

                    <div id="Sub63127565_1"
                      class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-4 col-md-4 col-lg-4"
                      positiontype="2" ismodulecontainer="true">

                      <div class="ModuleItem  StaticModule  mhidden-xs" wo="400" id="module_63127568">

                        <div class="ModuleImageTextGiant layout-101 layout-color-orange module_63127568 clearfix"
                          style="transform: translate3d(0px, 0px, 0px);">

                          <div class="BodyCenter BodyCenter63127568 clearfix">

                            <div class="imageTextGiant-Container imageTextContainer clearfix" hasresponsive="1"
                              autohide="0" hideheight="150" hidewidth="760">

                              <div class="ModuleImageTextGiantContent ModuleImageTextContent">

                                <div style="font-family:微软雅黑;">

                                  <p>

                                    <img alt="" ondragstart="return false"
                                      :src="siteList.site_logo"
                                      style="width: 138px; height: 50px; object-fit: contain; background: none;"
                                      delay-inited="true">

                                  </p>

                                  <p>&nbsp;</p>

                                  <p style="line-height: 2em;">

                                    <span style="color: rgb(165, 165, 165);">地址：{{siteList.company_address}}</span>

                                  </p>

                                  <p style="line-height: 2em;">

                                    <span style="color: rgb(165, 165, 165);">邮箱：{{siteList.contact_email}}</span>

                                  </p>



                                  <p style="line-height: 2em;">

                                    <span style="color: rgb(165, 165, 165);">总机：{{siteList.contact_phone}}</span>

                                  </p>



                                  <p style="line-height: 2em;">

                                    <span style="color: rgb(165, 165, 165);">电话：{{siteList.company_fax}}</span>

                                  </p>

                                </div>

                              </div>

                            </div>


                          </div>

                        </div>



                      </div>

                    </div>

                    <div class="clearfix visible-xs"></div>

                    <div id="Sub63127565_2"
                      class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-3 col-md-3 col-lg-3"
                      positiontype="2" ismodulecontainer="true">

                      <div class="ModuleItem  StaticModule  mhidden-xs" wo="300" id="module_63127569">

                        <div class="ModuleImageTextGiant layout-101 layout-color-orange module_63127569 clearfix"
                          style="transform: translate3d(0px, 0px, 0px);">



                          <div class="BodyCenter BodyCenter63127569 clearfix">

                            <div class="imageTextGiant-Container imageTextContainer clearfix" hasresponsive="1"
                              autohide="0" hideheight="150" hidewidth="760">

                              <div class="ModuleImageTextGiantContent ModuleImageTextContent">

                                <div style="font-family:微软雅黑;">

                                  <p style="line-height: 3em;">

                                    <img alt="" 
                                      :src="siteList.wechat_qr_code"
                                      style="width: 133px; height: 130px; object-fit: contain; background: none;"
                                      delay-inited="true">

                                  </p>



                                  <p style="line-height: 3em;color: rgb(165, 165, 165);">&nbsp; &nbsp; &nbsp; &nbsp;
                                    &nbsp; &nbsp;关注我们</p>

                                </div>



                              </div>

                            </div>

                          </div>

                        </div>



                      </div>

                    </div>

                    <div class="clearfix visible-xs"></div>

                    <div id="Sub63127565_3"
                      class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-5 col-md-5 col-lg-5"
                      positiontype="2" ismodulecontainer="true">

                      <div class="ModuleItem  StaticModule  mhidden-xs" wo="500" id="module_63129237">

                        <div class="ModulePlainTextGiant layout-101 layout-color- module_63129237 clearfix">



                          <div class="BodyCenter BodyCenter63129237 clearfix">

                            <div class="plainTextGiant-Container imageTextContainer clearfix" hasresponsive="1"
                              hidewidth="760">

                              <div style="display: flex; justify-content: space-around;" class="ModulePlainTextGiantContent ModuleImageTextContent">

                              
                                <ul>
                                  <p class="foot_title">关于我们</p>
                                  <router-link to="/about/about" class="foot_nav">公司简介</router-link>
                                  <router-link to="/about/development" class="foot_nav">发展历程</router-link>
                                  <router-link to="/about/businessDomain" class="foot_nav">业务版图</router-link>
                                  <router-link to="/about/corporateCulture" class="foot_nav">企业文化</router-link>
                                </ul>


                              
                                <ul >
                                  <p class="foot_title">服务与解决方案</p>
                                  <router-link v-for="(item,index) in serviceList.slice(0,4)" :key="index" :to="{path:'/service',query:{category_id:item.id,category_title:item.title}}" class="foot_nav">{{item.title}}</router-link>
                                </ul>


                             
                                <ul >
                                  <p class="foot_title"> 新闻中心</p>
                                  <router-link v-for="(item,index) in newsList.slice(0,4)" :key="index" :to="{path:'/news',query:{category_id:item.id,category_title:item.title}}" class="foot_nav">{{item.title}}</router-link>
                                </ul>


                                <ul >
                                  <p class="foot_title"> 联系我们</p>
                                  <router-link to="/contact/maps" class="foot_nav">联系我们</router-link>
                                  <router-link to="/contact/join" class="foot_nav">加入我们</router-link>
                                  <router-link to="/contact/feedback" class="foot_nav">意见反馈</router-link>
                                </ul>



                              </div>

                            </div>

                          </div>

                        </div>



                      </div>

                    </div>

                    <div class="clearfix visible-lg"></div>

                    <div class="clearfix visible-xs"></div>

                  </div>

                </div>


              </div>

            </div>



          </div>
          <div class="ModuleItem  StaticModule  " wo="1358" id="module_65934631" style="height: auto;">

            <div class="ModuleGridGiant layout-101 layout-color- module_65934631 clearfix">



              <div class="BodyCenter BodyCenter65934631 clearfix">

                <div class="ModuleGridContainer  ModuleGridContainer65934631" gridswidthmode="2">

                  <div class="row ModuleSubContainer">

                    <div class="gridBgVideo noBgVideo"><video src="" class="bgVideo" autoplay="" loop="loop"></video>

                      <div class="bgVideoMask"></div>

                    </div>

                    <div id="Sub65934631_1"
                      class="ModuleContainer SubContainer ModuleGridItem     col-xs-12 col-sm-12 col-md-12 col-lg-12"
                      positiontype="2" ismodulecontainer="true">

                      <div class="ModuleItem  StaticModule  mhidden-xs" wo="1200" id="module_65934632">

                        <div class="ModulePlainTextGiant layout-101 layout-color- module_65934632 clearfix">



                          <div  class="fir-foot BodyCenter BodyCenter65934632 clearfix">

                            <div class="plainTextGiant-Container imageTextContainer clearfix" hasresponsive="1"
                              hidewidth="760">

                              <div class="ModulePlainTextGiantContent ModuleImageTextContent">

                                <p style="text-align: center;">

                                  <span
                                    style="color: rgb(255, 255, 255); font-size: 14px; line-height: 150%;">版权所有2008-2025©
                                    {{siteList.company_name}}&nbsp; &nbsp;备案号：</span>

                                  <a href="https://beian.miit.gov.cn/" target="_blank">

                                    <span
                                      style="color: rgb(255, 255, 255); font-size: 14px; line-height: 150%;">{{siteList.icp_number}}</span>

                                  </a>

                                  <span style="color: rgb(255, 255, 255);"> 技术支持：<a style="color: rgb(255, 255, 255);"
                                      href="http://www.oodow.com/" target="_blank">友道科技</a> </span>

                                </p>



                              </div>

                            </div>


                          </div>

                        </div>



                      </div>

                      <div class="ModuleItem  StaticModule  mhidden-lg mhidden-md mhidden-sm" wo="1200"
                        id="module_441240075">

                        <div class="ModulePlainTextGiant layout-101 layout-color- module_441240075 clearfix">



                          <div class="BodyCenter BodyCenter441240075 clearfix">

                            <div class="plainTextGiant-Container imageTextContainer clearfix" hasresponsive="1"
                              hidewidth="760">

                              <div class="ModulePlainTextGiantContent ModuleImageTextContent">

                                <p style="text-align: center;">

                                  <span style="color: rgb(255, 255, 255); font-size: 14px; line-height: 150%;">版权所有©{{siteList.company_name}}</span>

                                </p>

                              </div>

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                    <div class="clearfix visible-lg"></div>

                    <div class="clearfix visible-xs"></div>

                  </div>

                </div>


              </div>

            </div>

          </div>
     </div>
     <div class="footer3" style="display: none;">
      <ul class="foot-nav-list" >
        <li itemid="7">
            <a href="/">
                      <svg t="1718183105053" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1699" width="22" height="22"><path d="M778 908.2H596.7c-26.2 0-47.6-21.4-47.6-47.6V678.5h-72v182.1c0 26.2-21.4 47.6-47.6 47.6H245.7c-26.2 0-47.6-21.4-47.6-47.6V561.8h-81.5c-20.1 0-37.6-12.2-44.6-31-7-18.7-1.7-39.3 13.3-52.4l387.7-346 0.2-0.2c25.6-22.1 63.6-21.3 88.4 1.7l380.1 345.6 0.2 0.2c14.3 13.5 18.9 34 11.6 52.2-7.2 18.2-24.6 30-44.2 30h-83.7v298.7c0 26.2-21.4 47.6-47.6 47.6z m-170.9-58h160.5V503.9h114.7l-360-327.3-0.1-0.1c-3.1-2.9-7.8-3-10.9-0.4L144 503.8h112.1v346.4h163V668.1c0-26.2 21.4-47.6 47.6-47.6h92.8c26.2 0 47.6 21.4 47.6 47.6v182.1z" p-id="1700" fill="#ffffff"></path></svg>
                    <span class="itemText  " style="display:block;">首页</span>
            </a>
        </li>
        <li itemid="2">
            <a href="tel:400-800-4949">
              <svg t="1718183305073" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2864" width="22" height="22"><path d="M752.881664 1024c-66.064384 0-151.355392-44.009472-211.273728-80.941056-80.242688-49.444864-166.68672-117.85216-243.41504-192.608256l-0.27648-0.27648-24.363008-24.367104c-74.760192-76.722176-143.161344-163.172352-192.6144-243.41504C44.015616 422.473728 0 337.18272 0 271.118336c0-70.69696 50.55488-145.73568 72.290304-174.712832C89.249792 73.791488 148.504576 0 198.85056 0c20.67456 0 42.938368 13.531136 72.198144 43.876352 25.880576 26.830848 50.714624 60.184576 66.988032 83.439616 21.858304 31.22176 42.070016 63.911936 56.92416 92.053504 24.049664 45.561856 26.832896 65.099776 26.832896 75.833344 0 21.661696-11.3152 40.450048-33.624064 55.83872-14.690304 10.131456-32.323584 17.760256-49.375232 25.141248-11.501568 4.974592-29.868032 12.914688-36.872192 18.499584 2.445312 10.350592 13.125632 35.34848 41.996288 77.73184 26.90048 39.491584 61.68576 82.290688 93.110272 114.563072 32.26624 31.420416 75.0592 66.209792 114.563072 93.110272 42.371072 28.85632 67.36896 39.542784 77.727744 41.990144 5.578752-7.00416 13.524992-25.36448 18.499584-36.866048 7.374848-17.055744 15.0016-34.691072 25.141248-49.381376 15.388672-22.308864 34.177024-33.61792 55.83872-33.61792 10.733568 0 30.271488 2.781184 75.839488 26.826752 28.135424 14.854144 60.831744 35.065856 92.049408 56.92416 23.25504 16.279552 56.60672 41.1136 83.443712 66.988032C1010.468864 782.211072 1024 804.47488 1024 825.14944c0 50.345984-73.785344 109.600768-96.39936 126.560256C898.617344 973.44512 823.578624 1024 752.881664 1024L752.881664 1024zM340.529152 707.278848c73.607168 71.702528 156.27264 137.148416 232.804352 184.30976 74.194944 45.725696 139.640832 71.950336 179.550208 71.950336 35.551232 0 86.23104-21.712896 135.579648-58.07104 21.633024-15.94368 41.322496-33.69984 55.441408-49.993728 13.248512-15.296512 18.092032-25.274368 19.320832-29.300736-5.117952-10.99776-35.528704-45.387776-106.504192-94.349312-27.84256-19.204096-56.623104-36.85376-81.0496-49.692672-30.6688-16.123904-43.450368-18.909184-46.37696-19.365888-1.13664 0.780288-4.476928 3.571712-9.555968 12.0832-5.6832 9.531392-11.147264 22.163456-16.427008 34.373632-6.5024 15.038464-13.232128 30.588928-21.48352 43.134976-13.416448 20.40832-29.89056 30.76096-48.959488 30.773248-0.346112 0-0.704512-0.006144-1.073152-0.018432-9.27744-0.196608-37.535744-0.796672-114.24768-53.041152-42.346496-28.852224-88.336384-66.254848-123.004928-100.069376l-0.54272-0.536576c-33.808384-34.678784-71.211008-80.662528-100.059136-123.004928-52.250624-76.711936-52.854784-104.968192-53.051392-114.251776-0.415744-19.417088 9.834496-36.179968 30.451712-49.831936 12.607488-8.3456 28.284928-15.12448 43.444224-21.686272 12.214272-5.279744 24.840192-10.745856 34.373632-16.422912 8.511488-5.072896 11.311104-8.419328 12.0832-9.555968-0.456704-2.926592-3.241984-15.706112-19.36384-46.37696-12.838912-24.420352-30.490624-53.20704-49.69472-81.043456-48.961536-70.981632-83.351552-101.390336-94.349312-106.508288-4.028416 1.232896-14.006272 6.076416-29.302784 19.324928-16.295936 14.112768-34.050048 33.806336-49.987584 55.441408-36.364288 49.342464-58.07104 100.022272-58.07104 135.573504 0 39.907328 26.220544 105.34912 71.944192 179.550208 47.16544 76.531712 112.613376 159.197184 184.30976 232.804352L340.529152 707.278848 340.529152 707.278848zM340.529152 707.278848" fill="#ffffff" p-id="2865"></path></svg>
                     <span class="itemText  " style="display:block;">电话咨询</span>
            </a>
        </li>
        <li itemid="3">
            <a href="#top" target="_self">
                    <!-- <span icontab="/public/img/2020041311131501898c.png" morenact="icon-zhiding-xuanzhong" moren="icon-zhiding-moren" activesicon="/public/img/2020041311131501898c.png" class="icon iconfont " style="color:#666;display:block;background-image:url(/public/img/2020041311131501898c.png);"> 
                    </span>-->
                    <svg t="1718183421272" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3913" width="22" height="22"><path d="M79.856 126.156V64.421h864.288v61.735H79.856z m61.735 432.146h30.867v-30.867h30.867v-30.867h30.867V465.7h30.867v-30.867h30.867v-30.87h30.867v-30.868h30.867V342.23h30.867v-30.867h30.867v-30.867h30.867v-30.867h30.867v-30.867h61.735v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.874v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.867v30.867h30.867v61.736H851.54v-30.867h-30.867v-30.868h-30.867V558.3H758.94v-30.867h-30.867v-30.867h-30.867v-30.867h-30.867v-30.867h-30.867v-30.868h-30.867v-30.867h-30.867V342.23H542.87v617.349h-61.738v-617.35h-30.867v30.867h-30.867v30.867h-30.867v30.867h-30.867v30.867h-30.867v30.867H295.93v30.867h-30.867v30.867h-30.867v30.867h-30.871v30.867h-30.867v30.867h-61.735v-61.735h30.867v-30.861z" fill="#ffffff" p-id="3914"></path></svg>
                   <span class="itemText  " style="display:block;">置顶</span>
            </a>
        </li>
     </ul>
   </div>
  </div>
</template>
<script>
export default {
  props:['siteList'],
  data() {
    return {
      // siteList:[],
      serviceList:[],
      newsList:[]
    }
  },
  created() {
    // this.getSite()
    this.getService()
    this.getNews()
    // this.$store.dispatch('getSite')
  },
  metaInfo() {
      return {
        meta: [
          {
            name: 'keywords',
            content:  this.siteList ? this.siteList.seo_keywords : ' ',
          },
          {
            name: 'description',
            content: this.siteList ? this.siteList.seo_description : ' ',
          },
        ],
      }
    },
    watch:{
     siteList:{
      handler(newVal){
        if (newVal.length > 0) {
          this.$nextTick(()=>{
            this.updateMetaInfo();
          })
        }
      },
      immediate: true, 
     }
    },
  methods: {
    updateMetaInfo() {
      this.$metaInfo.meta = [
        {
          name: 'keywords',
          content: this.siteList.seo_keywords,
        },
        {
          name: 'description',
          content: this.siteList.seo_description,
        },
      ];
    },
    // async getSite(){
    //   let res = await this.$request.post('seo/getSite')
    //   if (res.data.code===0) {
    //     this.siteList=res.data.data[0]
    //   }
    // },
    async getService(){
      let res = await this.$request.post('service/getAll')
      if (res.data.code===0) {
        this.serviceList=res.data.data
      }
    },
    async getNews(){
      let res = await this.$request.post('newscategory/getAll')
      if (res.data.code===0) {
        this.newsList=res.data.data
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .ModulePlainTextGiantContent>ul{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .foot_title{
    color:#d3d3d3 ;
    font-weight: 700;
  }
  .foot_nav{
    padding: 5px;
    color: #7b7b7b;
  }
  @media screen and (max-width:768px) {
    #module_63127565{
      display: none !important;
    }
  }
  @media screen and (max-width: 768px) {
    .fir-foot{
      display: none;
    }
  .footer3 {
    display: block !important;
    background-color: #333333;
    height: 3.125rem;
    z-index: 900;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
  }
  .footer3 .foot-nav-list {
    background-color: #262626;
  }
  .footer3 .foot-nav-list li {
    margin-top: 5px;
    display: block;
    -webkit-box-flex: 1;
    height: 100%;
    line-height: 100%;
    width: auto;
    float: left;
    width: 33.3%;
    text-align: center;
  }
  .footer3 .foot-nav-list li a {
    color: white;
  }
  .footer3 .foot-nav-list li a .icon-shouye1::before {
    content: "\e7b8";
  }
}
</style>